module.exports = __webpack_public_path__ + "img/V.1 250821 Icon Select Item Deleted svg0.41d51b03.svg";